/* cx: Kave-style footer — on mobile the link columns collapse into
   accordion rows toggled by their headings (+ / −). Desktop unaffected. */
(function () {
  'use strict';

  function isMobile() {
    return window.innerWidth < 750;
  }

  function wire() {
    document.querySelectorAll('.footer-block.grid__item').forEach(function (block) {
      var heading = block.querySelector('.footer-block__heading');
      if (!heading || heading.__cxAcc) return;
      heading.__cxAcc = true;
      heading.addEventListener('click', function () {
        if (!isMobile()) return;
        block.classList.toggle('is-open');
      });
      heading.addEventListener('keyup', function (e) {
        if (e.key === 'Enter' && isMobile()) block.classList.toggle('is-open');
      });
      heading.setAttribute('tabindex', '0');
    });
  }

  if (document.readyState !== 'loading') { wire(); } else { document.addEventListener('DOMContentLoaded', wire); }
})();
